import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { TICKET_STATUS_CLOSE } from '../../../assets/appConstants/constants';
import AddChip from '../../common/ActionChip/AddChip';
import { useNavigate } from 'react-router-dom';


export default function PrimaryMenuBar(props: any) {
  const { ticket_number, ticket_status_n } = props

  const navigate = useNavigate()

  return (
    <React.Fragment>
      <CssBaseline />
      <Container sx={{ my: { xs: 1, md: 1 }, p: { xs: 1, md: 2 } }}>
        <Box sx={{ display: 'inline-flex', position: 'absolute', right: '5%' }} >
          {((ticket_status_n) && ticket_status_n.id !== TICKET_STATUS_CLOSE.id) && (
            <AddChip
              label={"Nueva Actualización"}
              onClick={() => navigate(`/ticket/update/create/${ticket_number}`)}
            />)
          }
        </Box>
      </Container>
    </React.Fragment>
  );
}

